import { styled } from 'styled-components'

export const Footer = styled.div``
